module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/3df17861c6e19a36a9f33d6b4b650aa1.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_move_copy.svg
// module id = 5opF
// module chunks = 1